import { Navigate, Outlet } from 'react-router-dom'

/**
 * ProtectedRoute component guards routes that require authentication.
 * Redirects to login page if user is not authenticated.
 * Shows loading state while session is being verified.
 *
 * @param {Object} props - Component props
 * @param {Object|null} props.session - Current user session
 * @param {boolean} props.isLoading - Loading state during session check
 * @param {string} [props.redirectTo='/login'] - Path to redirect if not authenticated
 * @param {React.ReactNode} [props.children] - Optional children to render instead of Outlet
 * @returns {React.ReactElement} Protected route or redirect
 */
export default function ProtectedRoute({
  session,
  isLoading,
  redirectTo = '/login',
  children,
}) {
  // Guard: Still checking session, show nothing (parent can show GlobalLoader)
  if (isLoading) {
    return null
  }

  // Guard: No session, redirect to login
  if (!session) {
    return <Navigate to={redirectTo} replace />
  }

  // Session exists, render protected content
  // Use children if provided, otherwise render Outlet for nested routes
  return children || <Outlet />
}
